import { EventEmitter } from '@angular/core';
import { UtilitiesService } from '../../../services/utilities.service';
import { TrInputComponent } from '../tr-input/tr-input.component';
import { Component, Input, OnDestroy, AfterContentInit, Output } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Store } from '@ngrx/store';
import { AppState } from '../../../interfaces/app-state.interface';


@AutoUnsubscribe()
@Component({
    selector: 'tr-typeahead',
    templateUrl: './tr-typeahead.component.html',
    providers: [UtilitiesService],
})
export class TrTypeaheadComponent extends TrInputComponent implements OnDestroy, AfterContentInit {
    @Input() public removeAccents: boolean = false;
    @Input() public dataList: any;
    @Input() public options: any;

    public idSelected = null;

    @Output() public foundValue: EventEmitter<string> = new EventEmitter();

    constructor(
        store: Store<AppState>,
    ) {
        super(store);
    }

    public get selectedBank() {
        return {
            id: this.ControlReference.value,
            value: this.ControlReference.value,
        };
    }

    public ngAfterContentInit() {
        setTimeout(() => {
            const inputAutoComplete = document.getElementById('toro-autocomplete-' + this.options.id ).parentElement;
            inputAutoComplete.addEventListener('value-drop-change', (data: any) => {
                this.foundValue.emit(data.detail.id);
            });
        }, 5000);
    }

    // Não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    // tslint:disable-next-line: no-empty
    public ngOnDestroy() { }
}
